export default "__VITE_ASSET__058f4144__"